import { http, host, apiUrl, base } from '@/common'
const decode = require('jwt-decode')

function getToken() {
  return localStorage.getItem('token');
}

http.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers['x-access-token'] = token;
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers['X-Custom-Header'] = 'foobar';
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default {
  init ({ commit }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token') || null
      let user = {}
      
      if (token) {
        user = decode(token)
        commit('setUser', user)
        resolve({ state: true, user })
      } else {
        localStorage.removeItem('token')
        resolve({ state: false })
      }
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('removeUser');
      // localStorage.removeItem('token')
      resolve(true)
    })
  },
  login ({ commit }, postData) {
    return new Promise((resolve, reject) => {
      return http.post(`${host}/api/user/login`, postData)
        .then(({ data }) => {
          //  console.log(data)
          if (data.state) {
            localStorage.setItem('token', data.token)
          }
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  payment ({ commit }, id) {
    return new Promise((resolve, reject) => {
      return http.get(`${host}/web/system/subscription/${id}`)
        .then(({ data }) => {
          //console.log(data)
          //console.log(data);
          //resolve(data)
          const form = document.createElement('form');
          form.method = 'post';
          form.action = 'https://payments.ipayafrica.com/v3/ke';
          form.target = 'ipay_iframe';
          for (const key in data.fields) {
            if (data.fields.hasOwnProperty(key)) {
              const hiddenField = document.createElement('input');
              hiddenField.type = 'hidden';
              hiddenField.name = key;
              hiddenField.value = data.fields[key];

              form.appendChild(hiddenField);
            }
          }
          const hshField = document.createElement('input');
          hshField.type = 'hidden';
          hshField.name = 'hsh';
          hshField.value = data.hash;
          form.appendChild(hshField);

          document.body.appendChild(form);
          form.submit();
          document.getElementById('ipay_iframe').style.display='block';
          document.getElementById('package_items').style.display='none';
        }).catch((err) => {
          reject(err)
        })
    })
  },
  post ({ commit }, { data, url }) {
    return new Promise((resolve, reject) => {
      return http.post(`${apiUrl}${url}`, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((err) => { reject(err) })
    })
  },
  put ({ commit }, { data, url }) {
    return new Promise((resolve, reject) => {
      return http.put(`${apiUrl}${url}`, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((err) => { reject(err) })
    })
  },
  get ({ commit }, url) {
    return new Promise((resolve, reject) => {
      return http.get(`${apiUrl}${url}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((err) => { reject(err) })
    })
  },
  remove ({ commit }, url ) {
    return new Promise((resolve, reject) => {
      return http.delete(`${apiUrl}${url}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((err) => { reject(err) })
    })
  },
  getapi ({ commit }, url) {
    return new Promise((resolve, reject) => {
      return http.get(`${base}${url}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((err) => { reject(err) })
    })
  },
  postapi ({ commit }, { data, url }) {
    return new Promise((resolve, reject) => {
      return http.post(`${base}${url}`, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((err) => { reject(err) })
    })
  },
}
